<div class="modal-header d-flex justify-content-between align-items-center">
  <strong class="text-custom-theme bold fs-5">{{ prefix }}</strong>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>

<form #form="ngForm" class="form-validate">
  <div class="modal-body">
    <!-- ส่วนค้นหา -->
    <div class="row mb-4">
      <div class="col-12">
        <label for="search" class="form-label">ค้นหา</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="search"
            name="search"
            [(ngModel)]="term"
            placeholder="ค้นหาด้วย username หรือ email"
          >
          <button
            type="button"
            class="btn btn-custom btn-custom-theme"
            (click)="search()"
          >
            <i class="bi bi-search me-1"></i>
            <span class="d-none d-sm-inline">ค้นหา</span>
          </button>
        </div>
      </div>
    </div>

    <!-- ตารางข้อมูล -->
    <div class="table-responsive">
      <table class="table table-striped table-borderless">
        <thead class="color-black font-weight-light">
        <tr class="table-light text-center" style="background-color: #eeeeee;">
          <th scope="col" class="d-none d-md-table-cell">ลำดับ<br>No.</th>
          <th scope="col">ชื่อผู้ใช้<br>UserName</th>
          <th scope="col" class="d-none d-lg-table-cell">ชื่อ-นามสกุล<br>Name</th>
          <th scope="col" class="d-none d-md-table-cell">อีเมล<br>Email</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody class="table-borderless">
        <tr *ngIf="!pageData()?.content?.length">
          <td class="text-muted text-center" colspan="5">
            <app-not-found></app-not-found>
          </td>
        </tr>
        <tr *ngFor="let item of pageData()?.content; let i= index">
          <td class="text-center d-none d-md-table-cell">{{(pageData()?.number * pageData()?.size)+(i+1)}}</td>
          <td>
            <!-- แสดงข้อมูลสำคัญและซ่อนข้อมูลอื่นบนมือถือ -->
            <div class="d-flex flex-column">
              <span class="text-center">{{item.userName}}</span>
              <small class="text-muted d-lg-none">{{item.fullName}}</small>
              <small class="text-muted d-md-none">{{item.email}}</small>
            </div>
          </td>
          <td class="text-center d-none d-lg-table-cell">{{item.fullName}}</td>
          <td class="text-center d-none d-md-table-cell">{{item.email}}</td>
          <td class="text-center">
            @if(item.register){
              <button
                type="button"
                class="btn btn-sm btn-custom btn-custom-theme"
                (click)="save(item)"
              >
                <i class="bi bi-send me-1"></i>
                <span class="d-none d-md-inline">เพิ่มเจ้าหน้าที่</span>
                <span class="d-inline d-md-none">เพิ่ม</span>
              </button>
            }
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="d-flex justify-content-center mt-3">
      <ngb-pagination
        [maxSize]="5"
        [rotate]="true"
        [ellipses]="false"
        [boundaryLinks]="true"
        [page]="pageData()?.number + 1"
        (pageChange)="search($event)"
        [pageSize]="pageData()?.size"
        [collectionSize]="pageData()?.totalElements">
      </ngb-pagination>
    </div>
  </div>
</form>
